import { MouseEventHandler, ReactNode } from 'react';

import {
  ResponsiveSearchDrawerButton,
  ResponsiveSearchSubmitButtonWrapper,
} from './ResponsiveApplyButtonStyle';

const ResponsiveApplyButton = ({
  title = 'Uygula',
  onClick,
}: {
  title?: ReactNode;
  onClick?: MouseEventHandler<HTMLElement>;
}) => {
  return (
    <ResponsiveSearchSubmitButtonWrapper>
      <ResponsiveSearchDrawerButton htmlType='submit' onClick={onClick} block>
        {title}
      </ResponsiveSearchDrawerButton>
    </ResponsiveSearchSubmitButtonWrapper>
  );
};

export default ResponsiveApplyButton;
